import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { RoleTypeId, Role, RoleId, ActorType } from '../../types';
import {
	LARGE_SEARCH_THRESHOLD_TO_FORCE_HIDE_SEARCH_INPUT,
	POPUP_SELECT_WRAPPER_CLASSNAME,
} from './constants';
import type { DropdownItem, AddActorToRole, RemoveActorFromRole, CheckboxData } from './types';

export const rolesWidth = gridSize * 40;
export const rolesHeight = gridSize * 37.5;

export const getMenuListHeight = (isProjectSimplified: boolean, rolesLength: number): number =>
	isProjectSimplified && rolesLength > 3 ? rolesHeight + 30 : rolesHeight;

export const getDefaultPopupProps = () => ({
	backspaceRemovesValue: false,
	controlShouldRenderValue: false,
	isLoading: false,
	isSearchable: false,
	isClearable: false,
	searchThreshold: LARGE_SEARCH_THRESHOLD_TO_FORCE_HIDE_SEARCH_INPUT,
	closeMenuOnSelect: false,
	instanceId: 'roles-picker',
	className: POPUP_SELECT_WRAPPER_CLASSNAME,
});

export const transformProjectRolesForSelectCheckbox = (
	roles: Role[],
	selectedRoles: RoleId[],
): CheckboxData[] => // translatedName should always be present and will be made compulsary in a follow-up PR
	roles.map(({ id, translatedName = '', description }: Role): CheckboxData => {
		const isChecked = selectedRoles.indexOf(id) !== -1;
		return {
			id,
			title: translatedName,
			description,
			isChecked,
			isDisabled: isChecked && selectedRoles.length === 1,
			isManageRoles: false,
			value: id,
		};
	});

export const getRoleName = (roles: Role[], roleId: RoleId): string => {
	const role = roles.find((r) => roleId === r.id);
	return role?.translatedName || '';
};

export const onItemActivated = (
	roleTypeId: RoleTypeId,
	item: DropdownItem | CheckboxData,
	type: ActorType,
	addActorToRole: AddActorToRole | null | undefined,
	removeActorFromRole: RemoveActorFromRole | null | undefined,
	analyticsEvent: UIAnalyticsEvent,
): void => {
	const { id: roleId, isChecked } = item;
	if (isChecked) {
		addActorToRole && addActorToRole({ roleTypeId, addedRoleId: roleId, type, analyticsEvent });
	} else {
		removeActorFromRole &&
			removeActorFromRole({ roleTypeId, removedRoleId: roleId, type, analyticsEvent });
	}
};
